import { HomeData } from "./HomeData";
import { Hero } from "./Hero";
import { WhyChooseUsV2 } from "./WhyChooseUs";
import { OurProducts } from "./OurProducts";
import { ApplicationsSection } from "./Applications";
import { AccessoriesSection } from "./Accessories";
import { BrandLogos } from "./BrandLogos";
import { TestimonialSection } from "./Testimonial";
import { NeedCustomGlovebox } from "./NeedCustom";
import { useLocation } from "react-router-dom";
import React from "react";

export const Home = ()=> {  
   const location = useLocation();
  React.useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const element:any = document.getElementById(sectionId);
      const headerOffset = 120; // pixels you want to keep above
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      if (element) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);
  return (
    <div className="bg-gray-50 text-gray-900">
      <Hero {...HomeData.hero}/>
      <WhyChooseUsV2 {...HomeData.whyChooseUs}/>
      <OurProducts {...HomeData.OurProducts}/>
      <ApplicationsSection {...HomeData.ourApplication}/>
      <AccessoriesSection  {...HomeData.Accessories}/>
      <BrandLogos {...HomeData.brandLogo}/>
      <TestimonialSection {...HomeData.testimonials}/>
      <NeedCustomGlovebox {...HomeData.needCustom}/>
    </div>
  );
}
